'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addTimetokenToHistory = undefined;

var _update = require('transmute/update');

var _update2 = _interopRequireDefault(_update);

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _ifThen = require('transmute/ifThen');

var _ifThen2 = _interopRequireDefault(_ifThen);

var _isRecord = require('transmute/isRecord');

var _isRecord2 = _interopRequireDefault(_isRecord);

var _pubNubMessageKeyInvariant = require('../../invariants/pubNubMessageKeyInvariant');

var _threadHistoryInvariant = require('../../invariants/threadHistoryInvariant');

var _pubnubMessageGetters = require('../../pubnub-message/operators/pubnubMessageGetters');

var _keyPaths = require('../constants/keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Add a PubNub timetoken to a PubNubMessageRecord in a ThreadHistory
 *
 * @param {PubNubMessageKey} messageKey
 * @param {String} timetoken
 * @param {ThreadHistory} threadHistory
 * @returns {ThreadHistory}
 */
var addTimetokenToHistory = exports.addTimetokenToHistory = (0, _curry2.default)(function (messageKey, timetoken, threadHistory) {
  (0, _pubNubMessageKeyInvariant.pubNubMessageKeyInvariant)(messageKey);
  (0, _threadHistoryInvariant.threadHistoryInvariant)(threadHistory);

  return threadHistory.updateIn(_keyPaths.MESSAGES, (0, _update2.default)(messageKey, (0, _ifThen2.default)(_isRecord2.default, (0, _pubnubMessageGetters.setTimetoken)(timetoken))));
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-history/operators/addTimetokenToHistory.js
// module id = 613
// module chunks = 2 3